import { BodyText, Flex, IconButton, IconComponentName, Label } from "@braze/beacon-core";
import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";



type NavButtonProps = {
    icon: IconComponentName;
    title: string;
    description: string;
    link_path: string;
    children?: ReactNode;
    handleClick: Function;
}
export const NavButton = ({icon, title, description, link_path, children, handleClick} : NavButtonProps) => {

    const navigate = useNavigate();
    const buttonRedirect = (link : string) => navigate(link);

    return (
        <IconButtonBox>
            <IconButton 
                name={icon}
                aria-label="title"
                onClick={() => {
                    buttonRedirect(link_path);
                    handleClick()}}
                size="lg">{children}</IconButton>
            <TextBox>
                <Label 
                    onClick={() => {
                        buttonRedirect(link_path);
                        handleClick()}}>
                    {title}
                </Label>
                <BodyText>
                    {description}
                </BodyText>
            </TextBox>
            
            
        </IconButtonBox>
        
    )
}

const IconButtonBox = styled(Flex)`
    display: flex;
    flex-direction: row;
    padding-top: 1rem;
    // flex-basis: 0;
    // flex: 1 1 0px;
    
    Label {
        color: #2e3c47;
        font-size: 24px;
        letter-spacing: -0.75px;
        line-height: 40px;
        font-weight: normal;
        -webkit-font-smoothing: antialiased;
        cursor: pointer;
    }

`

const TextBox = styled(Flex)`
    flex-direction: column;
    margin-left: 1rem;
`